"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.questions.empty': 'Aún no hay preguntas configuradas para este paso.',
    'onboarding.questions.placeholder.text': 'Ingrese su respuesta',
    'onboarding.questions.placeholder.textarea': 'Ingrese su respuesta',
    'onboarding.questions.placeholder.number': 'Ingrese número',
    'onboarding.questions.placeholder.select': '-- Seleccionar Opción --',
    'onboarding.questions.required': '*',
};
